import {
	HomeOutlined,
	UserOutlined,
	UsergroupAddOutlined,
	FileTextOutlined,
	BankOutlined,
	ThunderboltOutlined,
	ShopOutlined,
	EnvironmentOutlined,
	SettingOutlined,
} from "@ant-design/icons";
import { APP_PREFIX_PATH } from "configs/AppConfig";
import {
	PermissaoGrupoUsuarioEnum,
	PermissaoUsuarioEnum,
	PermissaoTenantEnum,
	PermissaoCategoriaPermissaoEnum,
	PermissaoPermissaoEnum,
	PermissaoRequisicaoRecuperacaoSenhaEnum,
	PermissaoEmpresaVendedoraEnum,
	PermissaoTipoVendaEnum,
	PermissaoStatusAtivoEnum,
	PermissaoTipoInvestidorEnum,
	PermissaoAtivoEnum,
	PermissaoInvestidorEnum,
	PermissaoDistribuidoraEnum,
	PermissaoComercializadorGeradorEnum,
	PermissaoFaixaCepEnum,
	PermissaoComercializadorEnum,
	PermissaoParceiroEnum,
	PermissaoStatusCepEnum,
	PermissaoEnderecoUsinaEnum,
	PermissaoStatusGeradorEnum,
	PermissaoTipoGeradorEnum,
	PermissaoStatusPropostaEnum,
	PermissaoContaEnum,
	PermissaoEnderecoEnum,
	PermissaoConsumidorEnum,
	PermissaoPropostaEnum,
	PermissaoGeradorEnum,
} from "enum/permissao-enum";

const dashBoardNavTree = [
	{
		key: "dashboard",
		path: `${APP_PREFIX_PATH}/dashboard`,
		title: "dashboard",
		icon: HomeOutlined,
		breadcrumb: false,
		submenu: [],
	},
	{
		key: "lista-leads",
		path: `${APP_PREFIX_PATH}/lista-leads`,
		title: " Leads",
		icon: FileTextOutlined,
		breadcrumb: false,
		submenu: [],
		permissao: PermissaoPropostaEnum.VISUALIZAR_TELA,
	},
	{
		key: "lista-comercializador",
		path: `${APP_PREFIX_PATH}/lista-comercializador`,
		title: "Comercializadoras",
		icon: BankOutlined,
		breadcrumb: false,
		submenu: [],
		permissao: PermissaoComercializadorEnum.VISUALIZAR_TELA,
	},
	{
		key: "lista-parceiro",
		path: `${APP_PREFIX_PATH}/lista-parceiro`,
		title: "Parceiros",
		icon: UsergroupAddOutlined,
		breadcrumb: false,
		submenu: [],
		permissao: PermissaoParceiroEnum.VISUALIZAR_TELA,
	},
	{
		key: "lista-gerador",
		path: `${APP_PREFIX_PATH}/lista-gerador`,
		title: "Geradores / Usinas",
		icon: ThunderboltOutlined,
		breadcrumb: false,
		submenu: [],
		permissao: PermissaoGeradorEnum.VISUALIZAR_TELA,
	},
	{
		key: "lista-distribuidora",
		path: `${APP_PREFIX_PATH}/lista-distribuidora`,
		title: "Distribuidoras de Energia",
		icon: ShopOutlined,
		breadcrumb: false,
		submenu: [],
		permissao: PermissaoDistribuidoraEnum.VISUALIZAR_TELA,
	},
	{
		key: "lista-proposta",
		path: `${APP_PREFIX_PATH}/lista-proposta`,
		title: "Propostas",
		icon: FileTextOutlined,
		breadcrumb: false,
		submenu: [],
		permissao: PermissaoPropostaEnum.VISUALIZAR_TELA,
	},
	{
		key: "lista-investidor",
		path: `${APP_PREFIX_PATH}/lista-investidor`,
		title: "Investidores",
		icon: UserOutlined,
		breadcrumb: false,
		submenu: [],
		permissao: PermissaoInvestidorEnum.VISUALIZAR_TELA,
	},
	{
		key: "lista-empresa-vendedora",
		path: `${APP_PREFIX_PATH}/lista-empresa-vendedora`,
		title: "Empresas Vendedoras",
		icon: BankOutlined,
		breadcrumb: false,
		submenu: [],
		permissao: PermissaoEmpresaVendedoraEnum.VISUALIZAR_TELA,
	},
	{
		key: "lista-creditos-carbono",
		path: `${APP_PREFIX_PATH}/lista-creditos-carbono`,
		title: "Créditos de Carbono",
		icon: EnvironmentOutlined,
		breadcrumb: false,
		submenu: [],
		permissao: PermissaoAtivoEnum.VISUALIZAR_TELA,
	},
	{
		key: "configuracoes",
		path: `${APP_PREFIX_PATH}/configuracoes`,
		title: "Configurações",
		icon: SettingOutlined,
		breadcrumb: false,
		submenu: [],
		permissao: PermissaoUsuarioEnum.VISUALIZAR_TELA,
	},
	
];

const navigationConfig = [...dashBoardNavTree];

export default navigationConfig;
